import { render, staticRenderFns } from "./noticeForm.vue?vue&type=template&id=07571c4f&scoped=true&"
import script from "./noticeForm.vue?vue&type=script&lang=js&"
export * from "./noticeForm.vue?vue&type=script&lang=js&"
import style0 from "./noticeForm.vue?vue&type=style&index=0&id=07571c4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07571c4f",
  null
  
)

export default component.exports